// import { useState, useEffect, useCallback } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";

// import { FaBars } from "react-icons/fa";
// import CategoryList from "./CategoryList";
// import ProductCard from "../components/ProductCard";
// import HeroBanner from "../components/HeroBanner";

// import "../styles/home.css";

// export default function Home() {
//   const navigate = useNavigate();

//   const [products, setProducts] = useState([]);
//   const { categoryId } = useParams();

//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [page, setPage] = useState(0);
//   const [pageSize] = useState(100);
//   const [totalPages, setTotalPages] = useState(0);

//   const [sortField, setSortField] = useState("");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;

//   useEffect(() => {
//     if (categoryId) {
//       setSelectedCategory(categoryId);
//       setPage(0);
//     } else {
//       setSelectedCategory("");
//     }
//   }, [categoryId]);

//   useEffect(() => {
//     axios.get(PRODUCT_API + "/products/categories/").then((res) => {
//       setCategories(res.data?.content || []);
//     });
//   }, []);

//   const fetchData = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const res = await axios.get(PRODUCT_API + "/products/buyers", {
//         params: {
//           page,
//           size: pageSize,
//           sortField: sortField || undefined,
//           sortOrder,
//           categoryId: selectedCategory || undefined,
//         },
//       });

//       setProducts(res.data?.content || []);
//       setTotalPages(res.data?.totalPages || 0);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to fetch products.");
//     } finally {
//       setLoading(false);
//     }
//   }, [page, pageSize, sortField, sortOrder, selectedCategory, PRODUCT_API]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   return (
//     <div className="home-page">
//       {/* ================================= */}
//       {/* FULL WIDTH HERO */}
//       {/* ================================= */}
//       <HeroBanner />

//       {/* ================================= */}
//       {/* MOBILE CATEGORY BUTTON */}
//       {/* ================================= */}
//       {/* <div className="d-lg-none d-flex align-items-center border-bottom p-3 bg-white shadow-sm">
//         <button
//           className="btn p-0 me-3"
//           data-bs-toggle="offcanvas"
//           data-bs-target="#categorySidebar"
//         >
//           <FaBars size={22} />
//         </button>

//         <h6 className="fw-bold mb-0">Categories</h6>
//       </div> */}

//       {/* CATEGORY TOP BAR */}
//       <div className="d-flex align-items-center border-bottom p-3 bg-white shadow-sm">
//         <button
//           className="btn category-menu-btn p-0 me-3"
//           data-bs-toggle="offcanvas"
//           data-bs-target="#categorySidebar"
//         >
//           <FaBars size={22} />
//         </button>

//         <h6 className="fw-bold mb-0">Categories</h6>
//       </div>

//       {/* ================================= */}
//       {/* MOBILE SIDEBAR */}
//       {/* ================================= */}
//       <div
//         className="offcanvas offcanvas-start"
//         tabIndex="-1"
//         id="categorySidebar"
//       >
//         <div className="offcanvas-header border-bottom">
//           <h6 className="fw-bold">Categories</h6>

//           <button className="btn-close" data-bs-dismiss="offcanvas"></button>
//         </div>

//         <div className="offcanvas-body">
//           <CategoryList
//             categories={categories}
//             selectedCategory={selectedCategory}
//             onCategorySelect={(id) => {
//               navigate(`/category/${id}`);
//               setPage(0);
//             }}
//             itemProps={{ "data-bs-dismiss": "offcanvas" }}
//           />
//         </div>
//       </div>

//       {/* ================================= */}
//       {/* MAIN CONTENT */}
//       {/* ================================= */}
//       <div className="container-fluid mt-4">
//         <div className="row">
//           {/* DESKTOP SIDEBAR */}
//           {/* <div className="col-lg-3 d-none d-lg-block">
//             <div className="category-sidebar bg-white shadow-sm rounded p-3">
//               <h6 className="fw-bold mb-3">Categories</h6>

//               <CategoryList
//                 categories={categories}
//                 selectedCategory={selectedCategory}
//                 onCategorySelect={(id) => {
//                   navigate(`/category/${id}`);
//                   setPage(0);
//                 }}
//               />
//             </div>
//           </div> */}
//           {/* PRODUCTS */}
//           {/* <div className="col-12 col-lg-9">
//             <div className="row g-3">
//               {loading
//                 ? Array.from({ length: 12 }).map((_, idx) => (
//                     <div className="col-6 col-sm-4 col-md-3" key={idx}>
//                       <div className="card shadow-sm">
//                         <div className="skeleton-image"></div>

//                         <div className="card-body p-2">
//                           <div className="skeleton-text mb-2"></div>
//                           <div className="skeleton-text short"></div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 : products.map((product) => (
//                     <div className="col-6 col-sm-4 col-md-3" key={product.id}>
//                       <ProductCard product={product} />
//                     </div>
//                   ))}
//             </div>
//           </div> */}
//           {/* <div className="col-12 col-lg-9"> */}
//           <div className="col-12">
//             {loading ? (
//               <div className="home-loading-container">
//                 <div
//                   className="spinner-border text-primary home-loading-spinner"
//                   role="status"
//                 >
//                   <span className="visually-hidden">Loading...</span>
//                 </div>

//                 <p className="home-loading-text">Loading products...</p>
//               </div>
//             ) : (
//               <div className="row g-3">
//                 {products.map((product) => (
//                   <div className="col-6 col-sm-4 col-md-3" key={product.id}>
//                     <ProductCard product={product} />
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* PAGINATION */}
//         {totalPages > 1 && !loading && (
//           <div className="d-flex justify-content-center mt-4 pb-4">
//             <button
//               className="btn btn-outline-primary me-2"
//               onClick={() => setPage(page - 1)}
//               disabled={page === 0}
//             >
//               Previous
//             </button>

//             <span className="align-self-center fw-bold">
//               Page {page + 1} of {totalPages}
//             </span>

//             <button
//               className="btn btn-outline-primary ms-2"
//               onClick={() => setPage(page + 1)}
//               disabled={page + 1 >= totalPages}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FaBars } from "react-icons/fa";
import CategoryList from "./CategoryList";
import ProductCard from "../components/ProductCard";
import HeroBanner from "../components/HeroBanner";
import "../styles/home.css";
import Spinner from "../components/Spinner";

export default function Home() {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [cursor, setCursor] = useState(null);
  const [hasNext, setHasNext] = useState(true);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [error, setError] = useState("");
  const observer = useRef(null);

  // Reset when category changes
  useEffect(() => {
    setSelectedCategory(categoryId || "");
    setProducts([]);
    setCursor(null);
    setHasNext(true);
  }, [categoryId]);

  // Load categories
  useEffect(() => {
    axios
      .get(`${PRODUCT_API}/products/categories/`)
      .then((res) => setCategories(res.data?.content || []))
      .catch(console.error);
  }, [PRODUCT_API]);

  // Fetch products
  const fetchProducts = useCallback(async () => {
    if (loading || !hasNext) return;
    try {
      setLoading(true);
      setError("");
      const { data } = await axios.get(
        `${PRODUCT_API}/products/public/buyers`,
        {
          params: {
            cursor,
            limit: 20,
            categoryId: selectedCategory || undefined,
          },
        },
      );
      setProducts((prev) => [...prev, ...(data.content || [])]);
      setCursor(data.nextCursor);
      setHasNext(data.hasNext);
    } catch {
      setError("Failed to load products");
    } finally {
      setLoading(false);
      setInitialLoading(false);
    }
  }, [cursor, hasNext, loading, selectedCategory, PRODUCT_API]);

  // Initial load
  useEffect(() => {
    if (products.length === 0) fetchProducts();
  }, [selectedCategory]);

  // Infinite scroll
  const lastProductRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNext) fetchProducts();
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasNext, fetchProducts],
  );

  return (
    <div className="home-page">
      <HeroBanner />
      {/* Category Button */}
      <div className="d-flex align-items-center border-bottom p-3 bg-white shadow-sm">
        <button
          className="btn category-menu-btn p-0 me-3"
          data-bs-toggle="offcanvas"
          data-bs-target="#categorySidebar"
        >
          <FaBars size={22} />
        </button>
        <h6 className="fw-bold mb-0">Categories</h6>
      </div>

      {/* Category Sidebar */}
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="categorySidebar"
      >
        <div className="offcanvas-header border-bottom">
          <h6 className="fw-bold">Categories</h6>
          <button className="btn-close" data-bs-dismiss="offcanvas" />
        </div>
        <div className="offcanvas-body">
          <CategoryList
            categories={categories}
            selectedCategory={selectedCategory}
            onCategorySelect={(id) => navigate(`/category/${id}`)}
            itemProps={{ "data-bs-dismiss": "offcanvas" }}
          />
        </div>
      </div>

      {/* Products */}
      <div className="container-fluid mt-4">
        <div className="row g-3">
          {initialLoading ? (
            <Spinner />
          ) : (
            products.map((product, index) => {
              const last = index === products.length - 1;
              return (
                <div
                  key={product.id}
                  ref={last ? lastProductRef : null}
                  className="col-6 col-sm-4 col-md-3"
                >
                  <ProductCard product={product} />
                </div>
              );
            })
          )}
        </div>

        {loading && !initialLoading && (
          <div className="text-center my-4">
            <div className="spinner-border" />
            <p>Loading more products...</p>
          </div>
        )}

        {!hasNext && products.length > 0 && (
          <div className="text-center text-muted my-4">No more products</div>
        )}

        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
}
